import { of } from 'rxjs';
export function downloadUrl(url, filename = 'download') {
    const link = document.createElement('a');
    link.setAttribute('target', '_self');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
}
/**
 * Calling `downloadUrl()` within the `next` function in a subscription makes that function return early,
 * so the following statements won't be executed. This wrapper returns an `Observable`, and later we subscribe
 * to it to continue with the rest of the procedure.
 *
 * @param url
 */
export function downloadUrlWrapper(url) {
    downloadUrl(url);
    return of({});
}
export const downloadFileFromPostResponse = (response) => {
    const { headers } = response;
    const disposition = headers.get('content-disposition');
    const matches = /filename=([^;]+)/.exec(disposition);
    if (!matches) {
        // Reload the page so the user is redirected to log in
        window.location.reload();
        return;
    }
    const filename = matches[1];
    const blob = response.body;
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};
